// @ts-ignore
import { createRequestActionNames } from 'helpers'

export const FAVORITE_ACTIVITIES = createRequestActionNames('FAVORITE_ACTIVITIES', ['GET', 'POST', 'DELETE'])

export const FAVORITE_ACTIVITIES_SELECT_PAGE = 'FAVORITE_ACTIVITIES_SELECT_PAGE'
export const FAVORITE_ACTIVITIES_SET_FILTER = 'FAVORITE_ACTIVITIES_SET_FILTER'
